/*
 * @Author: your name
 * @Date: 2021-10-25 15:53:58
 * @LastEditTime: 2025-10-14 10:04:15
 * @LastEditors: yangguodong yanggd@geovis.com.cn
 * @Description: In User Settings Edit
 * @FilePath: \ngtc-traceability-admin\src\app\utils\http.ts
 */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class http {
  constructor(private httpClient: HttpClient) { }
  post(apiUrl: string, data: any, serverName: string = 'admin') {
    apiUrl = `${this.getServerHost(serverName)}${apiUrl}`;
    return this.httpClient.post(apiUrl, data, {
      responseType: 'json',
      headers: {
        contentType: 'application/json',
        Auth: '',
      },
    });
  }
  postBlob(apiUrl: string, data: any, serverName: string = 'admin'): Observable<Blob> {
    apiUrl = `${this.getServerHost(serverName)}${apiUrl}`;
    return this.httpClient.post(apiUrl, data, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        'Auth': '',
      },
    });
  }
  get<T>(apiUrl: string, serverName: string = 'admin') {
    apiUrl = `${this.getServerHost(serverName)}${apiUrl}`;
    return this.httpClient.get<T>(apiUrl, { responseType: 'json' });
  }
  getBlob(apiUrl: string, serverName: string = 'admin'): Observable<Blob> {
    apiUrl = `${this.getServerHost(serverName)}${apiUrl}`;
    return this.httpClient.get(apiUrl, {
      responseType: 'blob'
    });
  }
  delete(apiUrl: string, parameter?: any, serverName: string = 'admin') {
    apiUrl = `${this.getServerHost(serverName)}${apiUrl}`;
    return this.httpClient.delete(apiUrl, { responseType: 'json' });
  }
  getServerHost(serverName?: string): string {
    if (serverName) {
      switch (serverName) {
        case 'admin':
        case 'earth':
          return environment.apiServer.earth;
      }
    }
    return environment.apiServer.earth;
  }
}
